exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-stepper__content {\n  padding: 0 0 16px;\n}\n.v-stepper__label {\n  text-align: center !important;\n}\n.v-stepper--alt-labels .v-stepper__step {\n  -ms-flex-preferred-size: auto;\n      flex-basis: auto;\n}\n.v-stepper, .v-stepper__header {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}", ""]);

// exports
